import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Icon } from '../Icon/Icon';

interface Props {
  id: string;
  label: string;
  placeholder: string;
  onChange: (value: string) => void;
  value: string;
  className?: string;
  error?: string | boolean;
  showErrorOutLine?: boolean; // Case where we need the ability to show error outline if the input is 1 of 2 inputs
  isReadonly?: boolean;
  maxLength?: number;
}

export const TextArea = (props: Props) => {
  const {
    id,
    label,
    placeholder,
    onChange,
    value,
    className,
    error,
    showErrorOutLine,
    isReadonly,
    maxLength,
  } = props;

  const characterCount = (value || '').length;

  return (
    <div
      className={classNames('TextArea', className, { hasError: (!!error || showErrorOutLine), isDisabled: isReadonly })}
    >
      <label htmlFor={id}>
        <span className="TextArea-label">{label}</span>

        <textarea
          id={id}
          placeholder={placeholder}
          onChange={(e) => {
            onChange(e.target.value || '');
          }}
          value={value || ''}
          readOnly={isReadonly}
          disabled={isReadonly}
          rows={5}
          maxLength={maxLength}
        />

        <span className="TextArea-count">
          <span className="u-hiddenVisually"><FormattedMessage id="COUNT" /></span>
          {characterCount}/{maxLength}
        </span>

        {/* Error message */}
        {error && (
          <span className="TextArea-error">
            <Icon name="ic-exclamation" />{error}
          </span>
        )}
      </label>
    </div>
  );
};
